<template>
  <div>
    <viewTable
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="rtRoutes"
        :table-select="false"
        @addOrEdit="addEditHandle"
        @delete="deleteHandle">
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="工艺路线编号">
            <el-input v-model.trim="filter.routeNo" placeholder="请输入工艺路线编号" clearable/>
          </el-form-item>
          <el-form-item label="工艺路线名称">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
          <el-form-item label="工艺路线状态">
            <el-select v-model="filter.status" placeholder="请选择工艺路线状态" clearable>
              <el-option label="待确认" :value="10"/>
              <el-option label="已确认" :value="20"/>
              <el-option label="已作废" :value="90"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button type="primary" @click="$refs.rtRouteEdit.open(scope.row, 1)">详情</el-button>
        <el-button type="primary" @click="$refs.rtRouteCenterEdit.open(scope.row, 0)">工作中心</el-button>
      </template>
    </viewTable>
    <rt-route-edit ref="rtRouteEdit" @save-success="loadData"/>
    <rt-route-work-center-edit ref="rtRouteCenterEdit" @save-sucess="loadData"/>
  </div>
</template>

<script>
  import viewTable from "@/components/ViewTable.vue";
  import RtRouteEdit from "./RtRouteEdit";
  import RtRouteWorkCenterEdit from "@/views/information/RtRoute/RtRouteWorkCenterEdit";

  export default {
    name: "RtRouteList",
    components: {viewTable, RtRouteEdit, RtRouteWorkCenterEdit},
    data() {
      return {
        limits: {
          addAuth: this.$auth(213),
          editAuth: this.$auth(215),
          delAuth: this.$auth(217),
        },
        filter: {
          routeNo: "",
          routingName: "",
          status: "",
        },
        columnsProperty: [
          {
            key: "routeNo",
            width: 100,
            align: "center",
          },
          {
            key: "routeName",
            minWidth: 150,
            tooltip: true,
          },
          {
            key: "statusName",
            width: 100,
            align: "center",
          },
          {
            key: "note",
            width: 180,
            tooltip: true,
          },
          {
            key: "creatorName",
            width: 100,
            align: "center",
          },
          {
            key: "createTime",
            width: 160,
            align: "center",
          },
          {
            key: "action",
            align: "center",
            width: 280,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      // 新增、编辑
      addEditHandle(row) {
        this.$refs.rtRouteEdit.open(row);
      },

      // 加载数据
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 删除
      deleteHandle(row) {
        this.$http.post("basic", "rtRoutes/delete/"+row.pkid).then((resp) => {
          if (resp.success) {
            this.loadData();
            this.$message.success("删除成功");
          }
        });
      },
    },
  };
</script>
